const Waiver = require('@/lib/Waivers/Waiver');
const { hydrate } = require('@/lib/Hydration');
const { toInt, toIntArray, toString } = require('@/functions/transform');

class OrderWaiverStatus {
    /**
     * @type {number}
     */
    orderID;

    /**
     * @type {number}
     */
    completedWaiverCount = 0;

    /**
     * @type {number}
     */
    incompleteWaiverCount = 0;

    /**
     * @type {Waiver[]}
     */
    existingWaivers = [];

    /**
     * @type {string}
     */
    status;

    /**
     * @type {number[]}
     */
    itemsRequiringWaivers = [];

    constructor(data = {}) {
        hydrate(data, this);
    }

    getHydrationMap() {
        return {
            orderID: toInt,
            completedWaiverCount: toInt,
            incompleteWaiverCount: toInt,
            itemsRequiringWaivers: toIntArray,
            existingWaivers: {
                modelCollection: Waiver,
            },
            status: toString,
        };
    }

    /**
     * @return {boolean}
     */
    requiresWaivers() {
        return this.waiversPending() || this.waiversExist();
    }

    waiversPending() {
        return this.status === 'waivers_pending';
    }

    waiversExist() {
        return this.status === 'waivers_exist';
    }

    /**
     * @return {Waiver[]}
     */
    incompleteWaivers() {
        return this.existingWaivers.filter((w) => !w.isComplete());
    }

    /**
     * @return {boolean}
     */
    hasIncompleteWaivers() {
        return this.incompleteWaivers().length > 0;
    }

    /**
     * Returns true of any of the waivers on this order apply to *any* of the given itemIDs.
     *
     * @param {number[]} itemIDs
     *
     * @return {boolean}
     */
    containsWaiversForItems(itemIDs) {
        for (let i = 0; i < itemIDs.length; i++) {
            if (this.itemsRequiringWaivers.includes(itemIDs[i])) {
                return true;
            }
        }

        return false;
    }
}

module.exports = OrderWaiverStatus;
